// extracted by mini-css-extract-plugin
export default {"userEmail":"firstConfirmPage_userEmail__4VDmh","resultWrapper":"firstConfirmPage_resultWrapper__qUqfo"};